import { ReactNode, useEffect, useState } from 'react'
import ProductFruitsContext from './Context'
import { useGlobalAuth } from '@headbox-ui/auth-hook'
import setProductFruitsUserFromActor from '../../Utilities/ProductFruits/setProductFruitsUserFromActor'
import setProductFruitsUserFromEnquiry from '../../Utilities/ProductFruits/setProductFruitsUserFromEnquiry'
import { UserInfoFragment } from './ProductFruits.generated'

interface ProductFruitsProviderProps {
  enabled: boolean
  children: ReactNode
}

const ProductFruitsProvider = ({
  enabled,
  children,
}: ProductFruitsProviderProps): JSX.Element => {
  const { user } = useGlobalAuth()
  const [guestData, setGuestData] = useState<UserInfoFragment>()

  useEffect(() => {
    if (!enabled) return

    if (user) {
      setProductFruitsUserFromActor(user)
    } else if (guestData) {
      setProductFruitsUserFromEnquiry(guestData)
    }
  }, [enabled, user, guestData])

  return (
    <ProductFruitsContext.Provider value={{ setGuestData }}>
      {children}
    </ProductFruitsContext.Provider>
  )
}

export default ProductFruitsProvider
